// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3R8It","propertyOptions":"styles_propertyOptions__164BO"};